<template>
	<div class="card" v-if="errorMessage">
		<div class="card-header">
			<div class="card-header-title">
				Invitation Error
			</div>
		</div>
		<div class="card-content">
			<div class="content">
				{{ errorMessage }}
			</div>
		</div>
	</div>
</template>

<script>
import { AUTH_REQUEST } from '../store/actions/auth'
import { INIT_GET } from '../store/actions/init'

export default {

  data () {
    return {
      errorMessage: null
    }
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.dispatch(AUTH_REQUEST, {
        invite_id: to.params.inviteId
      }).then(response => {
        vm.$store.dispatch(INIT_GET).then(() => {
          next({
            name: 'account-dashboard',
            params: {
              id: response.account_id
            }
          })
        })
      }).catch(error => {
        vm.errorMessage = error.response.data.message
      })
    })
  }

}
</script>



// WEBPACK FOOTER //
// src/components/Invitation.vue